/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import PhotoGallery from "./component/PhotoGallery";
import Info from "./component/Info";
import { useProductos } from "../../hooks/useProductos";
import { useForm } from "../../hooks/useForm";
import { Link, useNavigate, useParams } from "react-router-dom";
import AccordionBike from "../Accordion";
import Model from "./component/Model";
import DrawerMenu from "./component/DrawerMenu";
// import { FirstProductImage } from "./component/data";
import './component/indexs.css'
import Loader from "../Loader";
import { bikes } from "../../utils/data";
import { WhatsAppButton } from "../ui/WhatsAppbutton";
import { useHome } from "../../contexts/HomeContext";
import { Images } from "lucide-react";


const Product = ({ comprar_ahora }) => {
  const { cart, productos, addCart, formatoCOP } = useProductos();
  const [producto, setProducto] = useState(null)
  const { form, onChange } = useForm({ cantidad: 1, size: producto?.inventories[0]?.size });
  const { cantidad, size } = form;
  const [color, setColor] = useState({
    dataC: '',
    index: 0
  })
  const { bicycles, scooters } = useHome()
  const { type } = useParams()
  const [indexImage, setIndexImage] = useState(0);
  const [count, setCount] = useState(1);
  const [open, setOpen] = useState(false);
  const [draw, setDraw] = useState(false);
  const handleOpen = () => setOpen(true);
  const { slug: id } = useParams();
  const [images, setImages] = useState()
  
  const [bgimage, setBgimage] = useState(null);
  const [parsedImages, setParsedImages] = useState(null);
  const [dimensions, setDimensions] = useState([])

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const tallasFilters = producto?.inventories
    .filter(objeto => objeto.color_hex === color.dataC) // Filtra por color "Amarillo"
    .map(objeto => objeto.size)
    setDimensions(tallasFilters);
   }, [color, producto])
  // Elimina colores repetidos usando Set
  const colores = producto?.inventories
    ? Array.from(new Set(producto.inventories.map(objeto => objeto.color_hex)))
    : [];

  console.log(colores)
  useEffect(() => {
    if (producto) setImages(producto?.inventories?.flatMap(obj => obj.images.map(img => img)))
    
    // Separar imágenes main y no-main y procesarlas
    const mainImages = producto?.inventories?.flatMap(inventory => 
      inventory.images
        .filter(img => img.is_main === 1)
        .map(img => ({ ...img, color_hex: inventory.color_hex }))
    ) || [];

    const nonMainImages = producto?.inventories?.flatMap(inventory => 
      inventory.images
        .filter(img => img.is_main !== 1)
        .map(img => ({ ...img, color_hex: inventory.color_hex }))
    ) || [];

    // Agrupar y filtrar solo las imágenes main
    const groupedMainImages = mainImages.reduce((acc, img) => {
      const color = img.color_hex;
      if (!acc[color]) acc[color] = img;
      return acc;
    }, {});

    // Combinar imágenes main filtradas con todas las no-main
    const imagesFLASH = [...Object.values(groupedMainImages), ...nonMainImages];

    console.log(imagesFLASH)
    if (producto?.inventories?.flatMap(obj => obj.images.map(img => img))) {
        const groupedByColor = imagesFLASH?.reduce((acc, img) => {
          const color = img.color_hex;
          acc[color] = acc[color] ? [...acc[color], img] : [img];
          return acc;
        }, {});

        const filteredImages = Object.values(groupedByColor)
          .map(group => group[0]);


        console.log(filteredImages)
        setBgimage(filteredImages[0]?.pathname);
      if (producto) setImages(imagesFLASH)
        console.log({ data: "dad", images})
        setColor({
          dataC: colores[0],
          index: 0
        })
    } else {
        setBgimage('');
    }
}, [producto, bicycles]);

  


useEffect(() => {
  if (id, type) {
    if (type == "scooter") {
      setProducto(scooters.find(scooter => scooter.slug == id))
    }
    
    else if (type == "bike") {
      console.log(scooters.find(scooter => scooter.slug == id))
      setProducto(bicycles.find(bike => bike.slug == id))
    }
  }
}, [id, type, bicycles]);

  
  const data = {
description: {
  h1: producto?.details?.name || '',
  ...(producto?.details?.peso && producto.details.peso !== '' && { peso: producto.details.peso }),
  ...(producto?.details?.tenedor && producto.details.tenedor !== '' && { tenedor: producto.details.tenedor }),
  ...(producto?.details?.tipo_marco && producto.details.tipo_marco !== '' && { tipoDeMarco: producto.details.tipo_marco }),
  ...(producto?.details?.frenos && producto.details.frenos !== '' && { frenos: producto.details.frenos }),
  ...(producto?.details?.grupo && producto.details.grupo !== '' && { grupo: producto.details.grupo }),
  ...(producto?.details?.manubrio && producto.details.manubrio !== '' && { manubrio: producto.details.manubrio }),
  ...(producto?.details?.tamaño_marco && producto.details.tamaño_marco !== '' && { tamañoDelMarco: producto.details.tamaño_marco }),
  ...(producto?.details?.marco && producto.details.marco !== '' && { marco: producto.details.marco }),
  ...(producto?.details?.llanta_delantera && producto.details.llanta_delantera !== '' && { llanta_delantera: producto.details.llanta_delantera }),
  ...(producto?.details?.llanta_trasera && producto.details.llanta_trasera !== '' && { llanta_trasera: producto.details.llanta_trasera }),
  ...(producto?.details?.cambiador && producto.details.cambiador !== '' && { cambiador: producto.details.cambiador }),
  ...(producto?.details?.descarrilador_delantero && producto.details.descarrilador_delantero !== '' && { descarrilador_delantero: producto.details.descarrilador_delantero }),
  ...(producto?.details?.descarrilador_trasero && producto.details.descarrilador_trasero !== '' && { descarrilador_trasero: producto.details.descarrilador_trasero }),
  ...(producto?.details?.platos_vielas && producto.details.platos_vielas !== '' && { platos_vielas: producto.details.platos_vielas }),
  ...(producto?.details?.cassette && producto.details.cassette !== '' && { cassette: producto.details.cassette }),
  ...(producto?.details?.cadena && producto.details.cadena !== '' && { cadena: producto.details.cadena }),
  ...(producto?.details?.ejes && producto.details.ejes !== '' && { ejes: producto.details.ejes }),
  ...(producto?.details?.vastago_manubrio && producto.details.vastago_manubrio !== '' && { vastago_manubrio: producto.details.vastago_manubrio }),
  ...(producto?.details?.tija_sillin && producto.details.tija_sillin !== '' && { tija_sillin: producto.details.tija_sillin }),
  ...(producto?.details?.sillin && producto.details.sillin !== '' && { sillin: producto.details.sillin }),
  ...(producto?.details?.rines && producto.details.rines !== '' && { rines: producto.details.rines }),

  // Especificaciones de scooters
  ...(producto?.details?.frame_material && producto.details.frame_material !== '' && { frame_material: producto.details.frame_material }),
  ...(producto?.details?.net_weight && producto.details.net_weight !== '' && { net_weight: producto.details.net_weight }),
  ...(producto?.details?.motor_power && producto.details.motor_power !== '' && { motor_power: producto.details.motor_power }),
  ...(producto?.details?.battery_type && producto.details.battery_type !== '' && { battery_type: producto.details.battery_type }),
  ...(producto?.details?.battery_capacity && producto.details.battery_capacity !== '' && { battery_capacity: producto.details.battery_capacity }),
  ...(producto?.details?.charger && producto.details.charger !== '' && { charger: producto.details.charger }),
  ...(producto?.details?.range && producto.details.range !== '' && { range: producto.details.range }),
  ...(producto?.details?.charging_time && producto.details.charging_time !== '' && { charging_time: producto.details.charging_time }),
  ...(producto?.details?.max_speed && producto.details.max_speed !== '' && { max_speed: producto.details.max_speed }),
  ...(producto?.details?.tyre_type && producto.details.tyre_type !== '' && { tyre_type: producto.details.tyre_type }),
  ...(producto?.details?.brake_type && producto.details.brake_type !== '' && { brake_type: producto.details.brake_type }),
  ...(producto?.details?.lights && producto.details.lights !== '' && { lights: producto.details.lights }),
  ...(producto?.details?.box_size && producto.details.box_size !== '' && { box_size: producto.details.box_size }),
  ...(producto?.details?.board_material && producto.details.board_material !== '' && { board_material: producto.details.board_material }),
  ...(producto?.details?.max_load && producto.details.max_load !== '' && { max_load: producto.details.max_load }),
  ...(producto?.details?.voltage && producto.details.voltage !== '' && { voltage: producto.details.voltage }),
  ...(producto?.details?.max_climbing_angle && producto.details.max_climbing_angle !== '' && { max_climbing_angle: producto.details.max_climbing_angle }),
  ...(producto?.details?.motor_drive && producto.details.motor_drive !== '' && { motor_drive: producto.details.motor_drive })
},

    dimensions: producto ? producto?.inventories?.map(ta => ta.size) : [],
    heights: [450, 480, 500, 520],
    price: `${producto?.price}`,
    tallas: producto?.tallas,
    slug: producto?.slug,
    peso: `${producto?.peso}`,
    bikes: images?.map((data, index) => {
      return {
        id: index + 1, // Asigna un id único basado en el índice
        color: index === 0 ? `rgb(70, 73, 77)` : index === 1 ? `rgb(10, 66, 84)` : `rgb(255, 255, 255)`,
        image: data?.pathname
      };
    })
  }

  const cellStyle = {
    padding: '8px',
    borderBottom: '1px solid #eee',
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#555',
  };




  return (
    <main style={{ paddingBottom: '100px' }}>

      <div className="Main-hero">
        <Model open={open} setOpen={(word) => setOpen(word)} />
        <DrawerMenu draw={draw} setDraw={(word) => setDraw(word)} />
        <section className="flexHero">
          <div style={{ marginInline: '30px', display: "flex", flexDirection: "column", alignItems: "center" }}>

            <PhotoGallery
              bgimage={bgimage}
              images={images}
              producto={producto}
              handleOpen={handleOpen}
              setBgimage={setBgimage}
              setIsLoading={setIsLoading}
              isLoading={isLoading}
            />

            <div className="buttons-color" style={{ marginTop: "30px" }}>


            </div>

            <div style={{ width: '400px', marginTop: "30px" }} className="information">

              <AccordionBike data={data}></AccordionBike>
            </div>

          </div>
          <div style={{ justifyContent: "center", display: "flex", width: "100%" }} className="information-desktop">

            <Info
              comprar_ahora={comprar_ahora}
              count={count}
              size={size}
              addCart={addCart}
              type={type}
              onChange={onChange}
              cantidad={cantidad}
              producto={producto}
              formatoCOP={formatoCOP}
              images={images}
              setCount={(word) => setCount(word)}
              setColor={setColor}
              color={color}
              setBgimage={setBgimage}
              colores={colores}
            />

          </div>

          <div className="information-mobile">

            <div style={{ width: '400px', display: "flex", justifyContent: "center" }} >

              <AccordionBike data={data}></AccordionBike>

            </div>
          </div>
        </section>
      </div>
      <WhatsAppButton />
    </main>
  );
};

export default Product;